/**
 * Registration flow step identifiers. These must match the camelCase strings returned by
 * GET /api/registration/me/steps. Each step component is assigned one so it can find itself in the
 * ordered steps list and work out the next step.
 */
export const RegistrationFlowStep = {
  UserDetails: 'userDetails',
  PetDetails: 'petDetails',
  // B21K only: the owner and pet details in one step, on the TOK details page.
  UserAndPetDetails: 'userAndPetDetails',
  MembershipOptions: 'paymentOptions',
  WelcomeGift: 'welcomeGift',
  Dashboard: 'dashboard',
} as const;

export type RegistrationFlowStepId =
  (typeof RegistrationFlowStep)[keyof typeof RegistrationFlowStep];

/**
 * The `type` returned by GET /api/registration/me/steps. Only the B21K flow changes
 * the routing: its details and payment steps are on the TOK pages.
 */
export const RegistrationFlowType = {
  FourStep: 'FourStepRegistrationFlow',
  ThreeStep: 'ThreeStepRegistrationFlow',
  NoPayment: 'NoPaymentRegistrationFlow',
  B21K: 'BreederToKeeperRegistrationFlow',
} as const;

/**
 * The registration steps in flow order,
 * used as a fallback for progress display before
 * GET /api/registration/me/steps resolves.
 */
export const REGISTRATION_STEP_ORDER: RegistrationFlowStepId[] = [
  RegistrationFlowStep.UserDetails,
  RegistrationFlowStep.PetDetails,
  RegistrationFlowStep.MembershipOptions,
  RegistrationFlowStep.WelcomeGift,
];

/** Maps a step identifier to the route a user is sent to when that step is the next one. */
export const STEP_ROUTES: Record<RegistrationFlowStepId, string> = {
  [RegistrationFlowStep.UserDetails]: '/account/owner-details',
  [RegistrationFlowStep.PetDetails]: '/claim-pet',
  [RegistrationFlowStep.UserAndPetDetails]: '/tok-details',
  [RegistrationFlowStep.MembershipOptions]: '/account/membership-options',
  [RegistrationFlowStep.WelcomeGift]: '/welcome-gift',
  [RegistrationFlowStep.Dashboard]: '/dashboard',
};
